// Magia Rosa · tema Shopify. JS mínimo: menú móvil y selector de formato del producto.
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-menu-toggle]');
    if (!btn) return;
    var menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) return;
    var abierto = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!abierto));
    btn.setAttribute('aria-label', abierto ? 'Abrir menú' : 'Cerrar menú');
    menu.hidden = abierto;
  });

  // Producto: al elegir formato, actualiza precio, id de variante y enlace de WhatsApp.
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-variante]');
    if (!input) return;
    var form = input.closest('[data-producto]');
    if (!form) return;
    var id = form.querySelector('input[name="id"]');
    if (id) id.value = input.value;
    var precio = form.querySelector('[data-precio]');
    if (precio) precio.textContent = input.dataset.precio;
    var wa = form.querySelector('[data-wa]');
    if (wa && wa.dataset.base) {
      var msg = wa.dataset.msg.replace('{formato}', input.dataset.nombre).replace('{precio}', input.dataset.precio);
      wa.href = wa.dataset.base + encodeURIComponent(msg);
    }
    var btn = form.querySelector('[data-agregar]');
    if (btn) {
      var disp = input.dataset.disponible === 'true';
      btn.disabled = !disp;
      btn.textContent = disp ? btn.dataset.textoOk : btn.dataset.textoNo;
    }
  });
})();
